import * as Yup from 'yup';
import { Dto } from "../../../parts/crud/dto";
import { group } from 'console';



export class userDto extends Dto {
  constructor() {
    super();
    this.data.initialValues = {

      name: '',
      mobile: '',
      email: '',
      roleId: '',
      password: '',
      password_confirm: '',
      groups: []
    };


    this.data.validationSchema = Yup.object({
      name: Yup.string().required('Il campo nome è obbligatorio'),

      email: Yup.string().email('Indirizzo email non valido').required('Il campo email è obbligatorio'),

      roleId: Yup.string().required('Il campo ruolo è obbligatorio'),
      password: Yup.string().required('Il campo password è obbligatorio').min(9, 'La password deve essere di almeno 9 caratteri'),
      password_confirm: Yup.string().required('Il campo conferma password è obbligatorio').oneOf([Yup.ref('password'), ""], 'Le password non corrispondono'),

    })
  }

  hookIsEdit = () => {
    this.data.validationSchema = Yup.object({
      name: Yup.string().required('Il campo nome è obbligatorio'),

      email: Yup.string().email('Indirizzo email non valido').required('Il campo email è obbligatorio'),

      roleId: Yup.string().required('Il campo ruolo è obbligatorio'),
      password: Yup.string().min(9, 'La password deve essere di almeno 9 caratteri'),
      password_confirm: Yup.string().oneOf([Yup.ref('password')], 'Le password non corrispondono')
    })
  }

  
}